<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble"><div class="pre" id="pre-002"><span epub:type="pagebreak" id="page_13" title="13"></span><h1 class="pre_tit" epub:type="title"><span>C<span class="small">HARACTERS IN THE</span> D<span class="small">RAMA</span></span></h1>
<div class="dev"><p class="txt_courant_justif">Caius Flavius <b>Amyntas</b>, a Christian and wealthy landowner, grandson of a freedman</p>
<p class="txt_courant_justif">Tiberius Claudius <b>Aristion</b>, high priest and temple warden of the Temple of the Sebastoi</p>
<p class="txt_courant_justif"><b>Burrhus</b>, a Christian in Amyntas’s house church</p>
<p class="txt_courant_justif"><b>Chreste</b>, the eleven-year-old daughter of Demetrius and Olympias</p>
<p class="txt_courant_justif">Flavia <b>Chrysanthe</b>, Amyntas’s wife</p>
<p class="txt_courant_justif">T. Julius Damas <b>Claudianus</b>, a member of <i>koinon</i> (the provincial council) of Asia and president of the civic council of Ephesus</p>
<p class="txt_courant_justif"><b>Demetrius</b>, son of Apollonius, a Christian merchant and host to a house church</p>
<p class="txt_courant_justif"><b>Diodotos</b>, an outspoken Christian artisan and member of Amyntas’s house church</p>
<p class="txt_courant_justif"><b>Euplus</b>, a Christian slave in Serapion’s house</p>
<p class="txt_courant_justif"><b>Fronto</b>, a Christian in Amyntas’s house church</p>
<p class="txt_courant_justif">Publius Aurelius <b>Hippicus</b>, son of Serapion and Isidora</p>
<p class="txt_courant_justif">Aurelia <b>Isidora</b>, Serapion’s wife</p>
<p class="txt_courant_justif"><b>Menes</b>, a slave in the household of Amyntas</p>
<p class="txt_courant_justif">Titus Flavius <b>Montanus</b>, eventually to be associated with the titles “high priest of Asia’s shared temple in Ephesos, <i>sebastophant</i>, and <i>agonothete</i> for life” in Ephesus</p>
<p class="txt_courant_justif"><span epub:type="pagebreak" id="page_14" title="14"></span><b>Nicolaus</b>, son of Strato, of Pergamum, a Christian and junior priest of the Provincial Temple of Augustus and Roma in Pergamum</p>
<p class="txt_courant_justif"><b>Olympias</b>, Demetrius’s wife</p>
<p class="txt_courant_justif"><b>Parmenon</b>, the steward in Serapion’s household</p>
<p class="txt_courant_justif"><b>Prochorus</b> of Smyrna, a Christian and a disciple of John the Seer, assisting him in his exile on Patmos</p>
<p class="txt_courant_justif">Aulus Julius <b>Quadratus</b> of Pergamum, who would become proconsul of Asia in 108/109—now chief of staff of the proconsul of Asia, Marcus Gillo</p>
<p class="txt_courant_justif">Gaius Vibius <b>Salutaris</b>, a local benefactor</p>
<p class="txt_courant_justif">Caius Flavius <b>Secundus</b>, son of Amyntas and Chrysanthe</p>
<p class="txt_courant_justif">Publius Aurelius <b>Serapion</b>, a wealthy landowner and a priest of Artemis</p>
<p class="txt_courant_justif"><b>Theon</b>, the eight-year-old son of Demetrius and Olympias</p>
<p class="txt_courant_justif"><b>Trophimus</b>, a onetime associate of Paul, an elder among the Ephesian churches</p>
<p class="txt_courant_justif">Flavia <b>Tryphaina</b>, daughter of Amyntas and Chrysanthe</p>
<p class="txt_courant_justif">Titus Flavius <b>Zeuxis</b>, a successful sea captain and merchant, an imperial freedman, and a Jew</p>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre3.vue?613682b0